import { usePrivateContextSavedSizesPermissions } from '~/components/v2/hooks/usePrivateContextSavedSizesPermissions';
import { usePrivateContextSourcesPermissions } from '~/components/v2/hooks/usePrivateContextSourcesPermissions';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';
import { useCurrentWorkspacePermissionsContext } from '~/providers/CurrentWorkspacePermissionsProvider';
import { useCanViewPrivateAddOn } from '~/swr-hooks/workspaces/addOns/useCanViewPrivateAddOn';
import { canViewPeople } from '~/utils/permissions/workspacePermissions';

export const usePrivateContextPeopleTabs = () => {
  const { generativeCanvasEnabled, savedSizesEnabled, ui2026 } = useTemporaryFeatureFlags();
  const { canView: canViewContextSources } = usePrivateContextSourcesPermissions();
  const { canView: canViewSavedSizes } = usePrivateContextSavedSizesPermissions();
  const { data: workspacePermissions } = useCurrentWorkspacePermissionsContext();
  const { canViewAddOn: canSeePrivatePeople } = useCanViewPrivateAddOn({ key: 'facialRecognition' });

  const canSeeBrandContentTab = ui2026 && generativeCanvasEnabled && canViewContextSources;
  const canSeePeopleTab = ui2026 && canViewPeople(workspacePermissions) && canSeePrivatePeople;
  const canSeeSavedSettingsTab = ui2026 && savedSizesEnabled && canViewSavedSizes;

  return {
    canSeeBrandContentTab,
    canSeePeopleTab,
    canSeeSavedSettingsTab,
  };
};
